/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-chart-point-image',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoChartPointImageComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get height(): number | { rangeMaxPoint?: number | undefined, rangeMinPoint?: number | undefined } {
        return this._getOption('height');
    }
    set height(value: number | { rangeMaxPoint?: number | undefined, rangeMinPoint?: number | undefined }) {
        this._setOption('height', value);
    }

    @Input()
    get url(): string | undefined | { rangeMaxPoint?: string | undefined, rangeMinPoint?: string | undefined } {
        return this._getOption('url');
    }
    set url(value: string | undefined | { rangeMaxPoint?: string | undefined, rangeMinPoint?: string | undefined }) {
        this._setOption('url', value);
    }

    @Input()
    get width(): number | { rangeMaxPoint?: number | undefined, rangeMinPoint?: number | undefined } {
        return this._getOption('width');
    }
    set width(value: number | { rangeMaxPoint?: number | undefined, rangeMinPoint?: number | undefined }) {
        this._setOption('width', value);
    }


    protected get _optionPath() {
        return 'image';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoChartPointImageComponent
  ],
  exports: [
    DxoChartPointImageComponent
  ],
})
export class DxoChartPointImageModule { }
